/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Clips_KickerInputs */

const en_road_dude_clips_kicker = /** @type {(inputs: Road_Dude_Clips_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`THE FOOTAGE`)
};

const zh_road_dude_clips_kicker = /** @type {(inputs: Road_Dude_Clips_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻拍片段`)
};

/**
* | output |
* | --- |
* | "THE FOOTAGE" |
*
* @param {Road_Dude_Clips_KickerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_clips_kicker = /** @type {((inputs?: Road_Dude_Clips_KickerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Clips_KickerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_clips_kicker(inputs)
	return zh_road_dude_clips_kicker(inputs)
});
export { road_dude_clips_kicker as "road_dude.clips.kicker" }